import { createClient } from '@supabase/supabase-js'

// const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL // "https://supabase.zapt.ai" //
const supabaseUrl = "https://supabase.zapt.ai"
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)